import { render, staticRenderFns } from "./MarketProductTableVariantProducer.vue?vue&type=template&id=48c6ba78&"
import script from "./MarketProductTableVariantProducer.vue?vue&type=script&lang=js&"
export * from "./MarketProductTableVariantProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports